import React, { useState, useEffect, useRef } from "react";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

type Props = {
  sortListProps: {
    sortOption: SortOption;
    sortOptions: SortOption[];
    setSortOption: (sortOption: string) => void;
  };
};

type SortOption = {
  field: string;
  id: string;
  visibility: string;
  direction: "asc" | "desc";
  position: number;
  name: string;
  handle: string;
};

export const Sort: React.FC<Props> = ({ sortListProps }) => {
  const [open, setOpen] = useState<boolean>(false);
  const { sortOption, sortOptions, setSortOption } = sortListProps;
  const [selected, setSelected] = useState<string>(sortOption.handle);
  const filterClasses = `thb-filter-dropdown sort ${open && "active-facets"}`;
  
  const ref = useRef(null);
  useOnClickOutside(ref, () => setOpen(false));

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleChange = (value: string) => {
    setSelected(value);
    setSortOption(value);
  };

  useEffect(() => {
    // listen for the esc key and close the filter
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    if (window) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      if (window) {
        window.removeEventListener("keydown", handleEsc);
      }
    }
  }, []);

  return (
    <div className="facets">
      <div ref={ref} className="thb-filter">
        <button onClick={handleOpen}>
          <span className="thb-filter-title">{sortOption.name}</span>
        </button>
        <div  className={filterClasses}>
          <div className="thb-filter-dropdown__inner">
            <ul>
              {sortOptions.map(({ id, name, handle }) => (
                <li key={id}>
                  <label htmlFor={id} >
                    <input
                      type="checkbox"
                      value={handle}
                      checked={handle === selected}
                      onChange={(event) => handleChange(event.target.value)}
                      name={id}
                    />
                    <span className="">{name}</span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <div className="thb-filter-dropdown__footer"></div>
        </div>
      </div>
    </div>
  );
};
